import React from 'react';

import { Button, Center, Text, VStack, theme } from '@squire/ui';

import { ScreenHeader } from '@/components/_shared/ScreenHeader';
import { useScreenTranslations } from '@/hooks/useScreenTranslations';

import { styles } from './styles';
import type { AdultOnlyConsentProps } from './types';

const AdultOnlyConsent = ({
  testID,
  onAgree,
  onClose,
  ...props
}: AdultOnlyConsentProps) => {
  const { t } = useScreenTranslations('AdultOnlyConsent');

  return (
    <VStack {...props} testID={testID} space={theme.spacing[8]}>
      <ScreenHeader
        title={t('title')}
        onClose={onClose}
        paddingVertical={theme.spacing[4]}
      />

      <VStack centerHorizontal centerVertical space={theme.spacing[7]}>
        <Center style={styles.iconContainer}>
          <Text variant="3xl" style={styles.text}>
            {t('ageRestriction')}
          </Text>
        </Center>

        <Text variant="xl" align="center" style={styles.descriptionContainer}>
          <Text variant="xl" color="textTertiary">
            {t('descriptionPrefix')}{' '}
          </Text>
          <Text variant="xl" color="textPrimary">
            {t('descriptionSuffix')}
          </Text>
        </Text>
      </VStack>

      <VStack>
        <Button
          testID="adult-consent-agree"
          variant="primary"
          onPress={onAgree}
        >
          {t('agree')}
        </Button>
      </VStack>
    </VStack>
  );
};

AdultOnlyConsent.displayName = 'AdultOnlyConsent';

export { AdultOnlyConsent };
